/**
 * @desc 解锁订单输入
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/unLock`, {
      method: "POST",

      ...options,
    }),
  );
}
